import { sendAnalytics } from "@/core/SendAnalytics";

/*
 * Product card data <br>
 * [`Allugears`, `Bivan`]
 */
export const productCardMixin = {
    data() {
        let isPreOrder = false;
        let currentOffers = this.product.offers.filter((offer) => offer.available);

        if (currentOffers.length === 0) {
            // проверка на предзаказ
            currentOffers = this.product.offers.filter((offer) => !offer.available);
            isPreOrder = true;
        }

        const previewImage =
            currentOffers[0].previewImage?.medium || this.product.previewImage?.medium;

        return {
            currentOffers,
            offer: currentOffers[0],
            offerId: currentOffers[0].id,
            previewImage,
            previewImageFromOffer: "",
            price: currentOffers[0].price,
            discountPrice: currentOffers[0].discountPrice,
            discountPercent: currentOffers[0].discountPercent,
            isPreOrder,
        };
    },
    computed: {
        productInCart() {
            return this.inCartList.includes(this.offerId.toString());
        },
        productName() {
            return this.product.shortName ? this.product.shortName : this.product.name;
        },
        offerImage() {
            return this.previewImageFromOffer || "";
        },
        productPath() {
            return {
                name: "Product",
                params: { slug: this.product.slug, offer: this.offerId },
            };
        },
    },
    methods: {
        onSelectColor(color) {
            const offer = this.currentOffers.find((offer) => offer.color.id === color.id);

            if (offer) {
                const { id, previewImage, available, price, discountPrice, discountPercent } =
                    offer;

                this.offerId = id;
                this.previewImageFromOffer = previewImage.medium;
                this.price = price;
                this.discountPrice = discountPrice;
                this.discountPercent = discountPercent;
                this.isPreOrder = !available;
            }
        },
        sendDataLayerEvent() {
            sendAnalytics.send(sendAnalytics.events.productClick, {
                name: this.product.name,
                offerId: this.offerId,
                price: this.discountPrice,
                position: this.position,
            });
        },
    },
};
